import { SET_WIZARD_STEP } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case SET_WIZARD_STEP:
      return action.payload;
    default:
      return state;
  }
};
